/*
import { validationMixin } from 'vuelidate';

export default {
    mixins: [validationMixin],
    
    methods: {
     
      validate() {
        this.$v.$touch();

        if (this.$v.$invalid) {
          let breakloop = false

          // 1. Loop no objeto raiz 
          for (let key in Object.keys(this.$v)) {
         
            // Extrai o nome do objeto raiz
            const jsonObj = Object.keys(this.$v)[key];

            // 2. Loop nos objetos field/jsonObj filhos de raiz 
            for (let key2 in Object.keys(this.$v[jsonObj])) {
              const fields = Object.keys(this.$v[jsonObj])[key2];

              // 3. Loop nas properts injetadas pelo Vuelidate para cada campo
              for (var property in this.$v[jsonObj][fields]) {
                if (property === '$invalid') {
                  if (this.$v[jsonObj][fields][property]) {
                    // 4. Foco primeiro jsonObj que encontrar inválido
                    this.$refs[jsonObj + '-' + fields].focus();
          
                    // 6. Break nos loops
                    breakloop = true
                    break;
                  }  
                  else {  
                    //console.log('PROPS = property [ $invalid ] = False')
                  }   
                }
              }

              if (fields.includes("$")) return false;

              if (breakloop) break
            }

            if (breakloop) break
          }

          if (breakloop) {
            return false
          }
          else {
            return true;
          }

        } 
        else {
          // Submit form ok
          return true;
        }

      },

    },
};
*/

import { validationMixin } from 'vuelidate';

export default {
  mixins: [validationMixin],

  methods: {
    validate() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        for (let key in this.$v) {
          if (key.startsWith('$')) continue; // Ignorar propriedades internas do Vuelidate

          const fieldSet = this.$v[key];
          
          for (let field in fieldSet) {
            if (field.startsWith('$')) continue; // Ignorar propriedades internas do Vuelidate

            if (fieldSet[field].$invalid) {
              // Definir foco no campo inválido
              const refKey = `${key}-${field}`;
              if (this.$refs[refKey]) {
                this.$refs[refKey].focus();
                return false;
              }
            }
          }
        }

        return false;
      }

      // Se não houver erros, o formulário é válido
      return true;
    },
  },
};
